export default __webpack_public_path__ + "media/design-system/icon/assets/brand/LG/calendar-dd05e6f6536d5166c7503937fe1fd6b8.svg";